import type { AxiosResponse } from 'axios';

import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';
import type { ClaimStatus } from '@/views/screens/Claims/types';

export interface ClaimStatusOption {
  key: ClaimStatus;
  value: string;
}

export const getClaimStatusAPI = () => {
  return axiosInstance.request({
    method: 'get',
    url: `${API.LOSS_AND_DAMAGE}/GetClaimStatus`,
  });
};

export type ClaimStatusResponse = ClaimStatusOption[];

export const fetchClaimStatus = async (): Promise<ClaimStatusResponse> => {
  const response: AxiosResponse<ClaimStatusResponse> = await getClaimStatusAPI();
  return response.data;
};
